"use client";

import { usePostHog } from "posthog-js/react";
import { useEffect } from "react";

type Props = {
	locale: string;
	companySlug: string;
	jobsCount: number;
};

/**
 * Fires `company_profile_viewed` once on mount for /companies/[slug].
 * Mirrors LandingViewBeacon (src/components/homepage/landing-view-beacon.tsx):
 * the page is ISR (deterministic per slug+locale), so a server-side capture
 * would only fire on cache revalidation, not per visitor. Renders null.
 */
export function CompanyProfileViewBeacon({
	locale,
	companySlug,
	jobsCount,
}: Props) {
	const posthog = usePostHog();
	useEffect(() => {
		posthog?.capture("company_profile_viewed", {
			company_slug: companySlug,
			jobs_count: jobsCount,
			locale,
		});
	}, [posthog, companySlug, jobsCount, locale]);
	return null;
}
